var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#72383D;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16707 -5816)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 60,
    height: 60,
    rx: 4,
    transform: "translate(16707 5816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.652,19.944V3H11.472v8.472H3V41.123H19.944V32.652H24.18v8.472H41.123V19.944ZM11.472,36.887H7.236V32.652h4.236Zm0-8.472H7.236V24.18h4.236Zm0-8.472H7.236V15.708h4.236Zm8.472,8.472H15.708V24.18h4.236Zm0-8.472H15.708V15.708h4.236Zm0-8.472H15.708V7.236h4.236Zm8.472,16.944H24.18V24.18h4.236Zm0-8.472H24.18V15.708h4.236Zm0-8.472H24.18V7.236h4.236Zm8.472,25.416H32.652V32.652h4.236Zm0-8.472H32.652V24.18h4.236Z",
    transform: "translate(16714.305 5824.282)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterprise);
export default __webpack_public_path__ + "static/media/icon_enterprise.028fab55fe157e4e34ca553adcb74246.svg";
export { ForwardRef as ReactComponent };